export default {
  title: 'Region',
  NAOnlyMessage: 'Please set your area code. This will be used for local dialling.',
  MultiWithNAMessage: 'Please set the country and area code for your region. This will be used for local dialling and phone number formatting.',
  MultiWithoutNAMessage: 'Please select which country you are located in. This will be used for local dialling and phone number formatting.',
  country: 'Country',
  areaCode: 'Area Code',
  areaCodePlaceholder: 'Enter Area Code',
};
